// assets/section-product-benefits.js
(() => {
  const MQL_DESKTOP = window.matchMedia("(min-width: 1025px)");
  const MQL_FINEPTR = window.matchMedia("(pointer: fine)");
  const MQL_REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");

  function canRun() {
    // desktop only, mouse/trackpad only, and honor reduced motion
    return MQL_DESKTOP.matches && MQL_FINEPTR.matches && !MQL_REDUCED.matches;
  }

  function initSection(sectionEl) {
    if (!sectionEl) return;

    // avoid double init
    if (sectionEl.dataset.pbSmoothInit === "inertia2") return;
    const stick = sectionEl.querySelector(".pb-left-stick");
    if (!stick) return;
    sectionEl.dataset.pbSmoothInit = "inertia2";

    // tunables (can be set via CSS vars from Liquid if you want)
    const cs   = getComputedStyle(sectionEl);
    const FOLLOW = parseFloat(cs.getPropertyValue("--pb-smooth-follow")) || 0.18;
    const MAX    = parseFloat(cs.getPropertyValue("--pb-smooth-max"))    || 48;
    const MULT   = parseFloat(cs.getPropertyValue("--pb-smooth-mult"))   || 1.0;

    let running = false;         // rAF loop state
    let rafId   = null;

    let smoothY = window.scrollY;
    let lastY   = window.scrollY;

    // rAF loop (one-direction inertia, no bounce)
    const frame = () => {
      rafId = null;
      const currentY = window.scrollY;
      const dy = currentY - lastY;
      lastY = currentY;

      // exponential follow (immediate reaction, smooth settle)
      smoothY += (currentY - smoothY) * FOLLOW;

      let offset = (smoothY - currentY) * MULT;

      // prevent overshoot sign flips; keep inertia one-direction
      if (Math.sign(offset) !== Math.sign(dy)) offset *= 0.5;

      // clamp tiny noise and extremes
      if (Math.abs(offset) < 0.05) offset = 0;
      if (offset >  MAX) offset =  MAX;
      if (offset < -MAX) offset = -MAX;

      // write transform
      if (offset) {
        stick.style.transform = `translate3d(0, ${offset}px, 0)`;
      } else if (stick.style.transform) {
        stick.style.transform = "";
      }

      // keep running while moving or while user is scrolling
      if (offset !== 0) {
        rafId = requestAnimationFrame(frame);
      } else {
        running = false;
      }
    };

    // kick the loop when needed
    const nudge = () => {
      if (!running) {
        running = true;
        rafId = requestAnimationFrame(frame);
      }
    };

    // run only when section is visible
    const io = new IntersectionObserver(
      (entries) => {
        const vis = entries[0]?.isIntersecting;
        if (vis && canRun()) {
          nudge();
          window.addEventListener("scroll", nudge, { passive: true });
          window.addEventListener("wheel", nudge, { passive: true });
        } else {
          window.removeEventListener("scroll", nudge);
          window.removeEventListener("wheel", nudge);
          if (rafId) cancelAnimationFrame(rafId);
          running = false;
          rafId = null;
          stick.style.transform = ""; // reset when not visible
        }
      },
      { root: null, threshold: 0.1 }
    );
    io.observe(sectionEl);

    // re-evaluate on media changes (mobile ↔ desktop, pointer changes, reduce motion)
    const recheck = () => {
      // trigger IO callback path to attach/detach listeners based on canRun()
      io.unobserve(sectionEl);
      io.observe(sectionEl);
    };
    MQL_DESKTOP.addEventListener?.("change", recheck);
    MQL_FINEPTR.addEventListener?.("change", recheck);
    MQL_REDUCED.addEventListener?.("change", recheck);

    // theme editor hot-swap cleanup
    const mo = new MutationObserver(() => {
      if (!document.body.contains(sectionEl)) {
        io.disconnect();
        MQL_DESKTOP.removeEventListener?.("change", recheck);
        MQL_FINEPTR.removeEventListener?.("change", recheck);
        MQL_REDUCED.removeEventListener?.("change", recheck);
        window.removeEventListener("scroll", nudge);
        window.removeEventListener("wheel", nudge);
        if (rafId) cancelAnimationFrame(rafId);
        running = false;
        rafId = null;
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function initAll() {
    document.querySelectorAll(".product-benefits").forEach((el) => {
      initSection(el);
    });
  }

  // normal storefront
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  // theme editor
  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target?.querySelector?.(".product-benefits") || e.target;
    if (root && root.classList && root.classList.contains("product-benefits")) {
      initSection(root);
    } else {
      initAll();
    }
  });
})();
